import React from "react";
import checkbox from "../../img/checkbox.png";
import checkbox_active from "../../img/checkbox_active.png";

export default class CheckBox extends React.Component {
  render() {
    const { onClick, label, checked, disabled } = this.props;

    return (
      <button
        type="button"
        className={`checkbox-wrapper ${disabled ? "disabled" : ""}`}
        onClick={onClick}
        disabled={disabled}
        aria-pressed={checked}
      >
        {label ? <span className="label">{label}</span> : null}

        <img
          className={`checkbox ${checked ? "checked" : "unchecked"}`}
          src={checked ? checkbox_active : checkbox}
          alt=""
          aria-hidden="true"
        />
      </button>
    );
  }
}
